import React from 'react';
import { Tooltip, Typography } from 'antd';
import type { SupplierOrderItemDto } from '../../../dto/supplierOrder';
import { formatProductDimensions } from '../../../utils/productDimensions';
import OrderQuantityPreview from './OrderQuantityPreview';
import './SupplierOrderProductsPreview.css';

const EMPTY_VALUE = '—';

interface SupplierOrderProductsPreviewProps {
  items?: SupplierOrderItemDto[];
}

const SupplierOrderProductsPreview: React.FC<SupplierOrderProductsPreviewProps> = ({ items }) => {
  if (!items?.length) {
    return <Typography.Text type="secondary">{EMPTY_VALUE}</Typography.Text>;
  }

  return (
    <div className="supplier-order-products-preview">
      {items.map((item, index) => {
        const dimensions = formatProductDimensions(item);

        return (
          <div key={item.id || `${item.name}-${index}`} className="supplier-order-products-preview__item">
            <div className="supplier-order-products-preview__copy">
              <Tooltip title={item.name}>
                <span className="supplier-order-products-preview__name">{item.name}</span>
              </Tooltip>
              {dimensions ? (
                <span className="supplier-order-products-preview__dimensions" title={dimensions}>
                  {dimensions}
                </span>
              ) : null}
            </div>
            <span className="supplier-order-products-preview__figures">
              <span className="supplier-order-products-preview__quantity">
                <OrderQuantityPreview line={item} />
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default SupplierOrderProductsPreview;
